export const ADD_MESSAGE_TO_ROOMSTORE = 'ADD_MESSAGE_TO_ROOMSTORE';
export const REMOVE_MESSAGE_FROM_ROOMSTORE = 'REMOVE_MESSAGE_FROM_ROOMSTORE';
export const CLEAR_ROOMSTORE = 'CLEAR_ROOMSTORE';
//you can add others like set_loading_true, set_loading_false